// extracted by mini-css-extract-plugin
export default {"page":"gY-z","cartModal":"hY-z","checkout":"iY-z","placeholder":"jY-z","account":"kY-z"};